"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getFont = ({ theme: { fontFamily, fontSize, fontStretch, fontStyle, fontWeight, letterSpacing, lineHeight, }, }) => `
  font-family: ${fontFamily};
  font-size: ${fontSize};
  font-stretch: ${fontStretch};
  font-style: ${fontStyle};
  font-weight: ${fontWeight};
  letter-spacing: ${letterSpacing};
  line-height: ${lineHeight};
`;
exports.default = getFont;
